/* Vaciar carrito (sep 2026). Lo carga snippets/carnibox-head.liquid.
   Agrega un boton "Vaciar carrito" en el encabezado del carrito lateral
   (cart-drawer de Dawn) y en la pagina /cart. Pide confirmacion, llama a
   /cart/clear.js y recarga la pagina para que todo quede en cero.
   Dawn vuelve a dibujar el carrito al agregar o quitar productos, por eso se
   vigila el DOM y el boton se vuelve a poner si desaparece. Solo se muestra
   cuando hay productos.
   En el carrito lateral la X de cerrar de Dawn va en posicion absoluta arriba
   a la derecha: el boton deja ese espacio libre (margen derecho de 64 px). */
(function(){
  var TXT = 'Vaciar carrito';
  var ICONO = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ocupado = false;

  function css(){
    if(document.getElementById('cbv-css')) return;
    var st = document.createElement('style'); st.id = 'cbv-css';
    st.textContent =
      '.cbv-btn{display:inline-flex;align-items:center;gap:8px;border:1.5px solid #E7C9C5;background:#fff;color:#D62828;border-radius:999px;' +
      'min-height:42px;padding:0 18px;cursor:pointer;font-family:Montserrat,sans-serif;font-weight:700;font-size:15px;letter-spacing:.02em;line-height:1;white-space:nowrap;transition:background .15s,color .15s,border-color .15s}' +
      '.cbv-btn svg{flex-shrink:0}' +
      '.cbv-btn:hover{background:#D62828;border-color:#D62828;color:#fff}' +
      '.cbv-btn:disabled{opacity:.6;cursor:wait}' +
      '.cbv-btn:focus-visible{outline:3px solid #1A1614;outline-offset:2px}' +
      '.drawer__header{position:relative}' +
      '.drawer__header .cbv-btn{margin-left:auto;margin-right:64px}' +
      '.title-wrapper-with-link .cbv-btn{margin-left:auto;margin-right:16px}' +
      '@media (max-width:420px){.drawer__header .cbv-btn{font-size:13px;padding:0 14px;min-height:38px;margin-right:56px}}';
    document.head.appendChild(st);
  }

  function vaciar(b){
    if(ocupado) return;
    if(!window.confirm('\u00bfVaciar el carrito? Se quitan todos los productos.')) return;
    ocupado = true; b.disabled = true; b.lastChild.textContent = 'Vaciando\u2026';
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function(){ window.location.reload(); })
      .catch(function(){ ocupado = false; b.disabled = false; b.lastChild.textContent = TXT; window.alert('No pudimos vaciar el carrito. Intenta de nuevo.'); });
  }

  function crear(){
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'cbv-btn';
    b.innerHTML = ICONO + '<span>' + TXT + '</span>';
    b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); vaciar(b); });
    return b;
  }

  function poner(){
    /* Carrito lateral */
    var drawer = document.querySelector('cart-drawer');
    if(drawer){
      var cab = drawer.querySelector('.drawer__header');
      var vacio = drawer.classList.contains('is-empty') || !drawer.querySelector('.cart-item');
      var ya = cab && cab.querySelector('.cbv-btn');
      if(cab && !vacio && !ya){
        var cerrar = cab.querySelector('.drawer__close');
        cab.style.display = 'flex'; cab.style.alignItems = 'center';
        cab.insertBefore(crear(), cerrar || null);
      } else if(ya && vacio){ ya.remove(); }
    }
    /* Pagina del carro */
    var tit = document.querySelector('.title-wrapper-with-link');
    if(tit){
      var hay = !!document.querySelector('cart-items .cart-item');
      var ya2 = tit.querySelector('.cbv-btn');
      if(hay && !ya2){ var link = tit.querySelector('a'); tit.insertBefore(crear(), link || null); }
      else if(!hay && ya2){ ya2.remove(); }
    }
  }

  var pend = false;
  function pedir(){ if(pend) return; pend = true; setTimeout(function(){ pend = false; poner(); }, 60); }
  function iniciar(){
    css(); poner();
    new MutationObserver(pedir).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
